import React from 'react';

const ChevronDown = props => (
    <svg viewBox="0 0 13 8" {...props}>
        <polygon points="11.6287738 0 6.49951547 5.21413619 1.37025717 0 0 1.3929319 6.49951547 8 13 1.3929319" />
    </svg>
);

export default ChevronDown;
